export const languageFr = {
    dashboard: 'Tableau de bord',
    logout: 'Se déconnecter',
    games: 'LOTO 5/90',
    report: 'Rapports',
    result: 'Résultats',
    about: 'À propos',
    print: 'Imprimer',
    chance: 'Chance',
    nap: 'Nap',
    turbo: 'Turbo',
    'guinne turbo': 'Loto turbo',
    'guinne nap': 'Loto nap',
    'guinne chance': 'Loto chance +',
    'confirm delete': 'Confirmation de la suppression.',
    'ask me later': 'Demande moi plus tard',
    'are you sure you want to delete?': 'Êtes-vous sûr de vouloir supprimer?',
    'are you sure you want to delete': 'Êtes-vous sûr de vouloir supprimer',
    add: 'Ajouter',
    total: 'Total',
    clear: 'Effacer',
    pay: 'Validé',
    no: 'Ticket:',
    cancel: 'Annuler',
    close: 'Fermer',
    ok: 'Ok',
    back: 'Retour',
    confirm: 'Confirmer',
    select: 'Sélection',
    game: 'Jeu',
    wager: 'Mise',
    qp: 'QP',
    'please choose from 0 to 2 numbers': 'Attention ! Choisissez de 0 à 2 numéros',
    'please choose from 0 to 3 numbers': 'Attention ! Choisissez de 0 à 3 numéros',
    'please choose from 0 to 4 numbers': 'Attention ! Choisissez de 0 à 4 numéros',
    'please choose from 0 to 5 numbers': 'Attention ! Choisissez de 0 à 5 numéros',
    'please choose from 1 to 2 numbers': 'Attention ! Choisissez de 1 à 2 numéros',
    'please choose from 1 to 3 numbers': 'Attention ! Choisissez de 1 à 3 numéros',
    'please choose from 1 to 4 numbers': 'Attention ! Choisissez de 1 à 4 numéros',
    'please choose from 1 to 5 numbers': 'Attention ! Choisissez de 1 à 5 numéros',
    'please choose from 2 to 2 numbers': 'Attention ! Choisissez de 2 à 2 numéros',
    'please choose from 2 to 3 numbers': 'Attention ! Choisissez de 2 à 3 numéros',
    'please choose from 2 to 4 numbers': 'Attention ! Choisissez de 2 à 4 numéros',
    'please choose from 2 to 5 numbers': 'Attention ! Choisissez de 2 à 5 numéros',
    'please choose from 3 to 4 numbers': 'Attention ! Choisissez de 3 à 4 numéros',
    'please choose from 3 to 5 numbers': 'Attention ! Choisissez de 3 à 5 numéros',
    'please make sure that you select 2 of balls!': 'Attention ! Choisissez 2 numéros.',
    'please make sure that you select 3 of balls!': 'Attention ! Choisissez 3 numéros.',
    'please make sure that you select 4 of balls!': 'Attention ! Choisissez 4 numéros.',
    'please make sure that you select 5 of balls!': 'Attention ! Choisissez 5 numéros.',
    'amount due': 'Montant dû',
    confirmation: 'Confirmation',
    'cash received': 'Somme reçue',
    'cash change': 'Monnaie à rendre',
    'cash payment': 'Somme due',
    'cash report': 'Rapport de trésorerie',
    'select date': 'Sélectionner une date',
    'cash deposits': 'Ventes',
    cancellations: 'Annulations',
    wagers: 'Mises',
    winnings: 'Gains',
    payouts: 'Paiements',
    'daily profit': 'Solde du jour',
    'float adjustments': 'Dépôts',
    'cash difference': 'Solde du jour',
    results: 'Résultats',
    'guinee chance': 'Chance de Guinée',
    date: 'Date',
    'about games': 'A propos des jeux',
    'loto turbo': 'Loto turbo',
    'loto nap': 'Loto nap',
    'loto chance': 'Loto chance +',
    'nap 2: 2 numéros gagnants': 'Nap 2: 2 numéros gagnants',
    'nap 3: 3 numéros gagnants': 'Nap 3: 3 numéros gagnants',
    'nap 4: 4 numéros gagnants': 'Nap 4: 4 numéros gagnants',
    'nap 5: 5 numéros gagnants': 'Nap 5: 5 numéros gagnants',
    'chance 2: 2 numéros gagnants': 'Chance 2: 2 numéros gagnants',
    'chance 3: 3 numéros gagnants': 'Chance 3: 3 numéros gagnants',
    'chance 4: 4 numéros gagnants': 'Chance 4: 4 numéros gagnants',
    'chance 5: 5 numéros gagnants': 'Chance 5: 5 numéros gagnants',
    'turbo 2: 2 numéros gagnants': 'Turbo 2: 2 numéros gagnants',
    'turbo 3: 3 numéros gagnants': 'Turbo 3: 3 numéros gagnants',
    'turbo 4: 4 numéros gagnants': 'Turbo 4: 4 numéros gagnants',
    'turbo 5: 5 numéros gagnants': 'Turbo 5: 5 numéros gagnants',
    'nombre de numéros gagnants': 'Nombre de numéros gagnants',
    mise: 'Mise',
    'gains en gnf': 'Gains',
    rescan: 'Rescanner',
    'back to home': 'Retour a page principale',
    loading: 'Chargement en cours',
    'loading...': 'Chargement en cours...',
    alert: 'Alerte',
    'please input ticket number!': 'Veuillez entrer le numéro de billet ',
    error: 'Erreur',
    search: 'Valider le ticket',
    'close scan': 'Fermer le scan',
    scan: 'Scan',
    'ticket number': 'Numéro de billet',
    'scan ticket': 'Scanner le ticket',
    'ticket code': 'Code ticket',
    'code ticket': 'Code ticket',
    or: 'Ou',
    'ticket details': 'Détails du ticket',
    'purchase date': "Date d'achat",
    'payment received': 'Paiement reçu',
    ticket: 'Ticket',
    draw: 'Tirage',
    'draw date': 'Date du tirage',
    'make payment': 'Effectuer le paiement',
    settling: 'Paiement',
    settle: 'Payer',
    'no winnings': 'Pas de gains',
    'payment made': 'Paiement effectué',
    'payment date': 'Date de paiement',
    amount: 'Montant',
    reference: 'Référence',
    'please input email and password!': 'Veuillez insérer votre adresse e-mail et mot de passe',
    'please input mobile number and pin!': 'Veuillez insérer le numéro de téléphone et le code PIN',
    'system error! Please try again later!': 'Erreur du système! Veuillez réessayer plus tard',
    login: 'Connexion',
    'login by email': 'Connexion par address E-mail',
    'login by phone': 'Connexion par numéro de téléphone',
    'login terminal': 'Log-in detaillant',
    terminal: 'User ID',
    'terminal pin': 'Mot de passe',
    email: 'Adresse E-mail',
    password: 'Mot de passe',
    'mobile Pin': 'Pin téléphonique',
    mobile: 'Téléphone',
    'guinee lotto 5/90': 'Loto 5/90',
    'lotto 5/90': 'Loto 5/90',
    'guinee lotto 6/45': 'Loto 6/45',
    'report of': 'Rapport de',
    'final report of': 'RAPPORT Final du jour',
    receipt: 'Reçu',
    branch: 'Agence',
    cashier: 'Revendeur',
    code: 'Code',
    settlement: 'Paiement',
    'guinee lottery': 'LONAGUI',
    end: 'FIN',
    'empty result': 'Aucun résultat',
    warning: 'Attention',
    'play again': 'JOUER A NOUVEAU',
    submitting: 'Soumission',
    'pending results': 'Résultats en attente',
    'the amount entered is less that the amount required!': 'La somme reçue est inférieure au montant dû!',
    'system error!': 'Erreur du système!',
    'error - insufficient credit on the account': 'Attention ! Solde insuffisant sur votre compte',
    previous: 'Précédent',
    next: 'Prochain',
    'all winning bets are cashout already!': 'Attention! Ce ticket a déjà été payé',
    'ticket not found': 'Ticket introuvable',
    'not found': 'PAS TROUVÉ',
    'please input old pin and new pin!': "Veuillez entrer l'ancienne broche et la nouvelle broche !",
    'change pin': 'Modifier le PIN',
    'old pin': 'Ancien PIN',
    'new pin': 'Nouveau PIN',
    'new pin retype': 'Confirmation du nouveau code PIN',
    'cashier need to login again after pin is changed.':
        'Le caissier doit se reconnecter une fois le code PIN modifié.',
    'terminal pin must be digit number, minimum length is 6 and maximum length is 20!':
        'Le code PIN du terminal doit être composé de chiffres, la longueur minimale est de 6 et la longueur maximale est de 20 !',
    'terminal pin is not initialized at start. Please contact admin!':
        "Le PIN du terminal n'est pas initialisé au démarrage. Veuillez contacter l'administrateur !",
    'old terminal pin is not matched!': "L'ancien code PIN du terminal ne correspond pas !",
    'pin is changed!': 'Le code PIN est modifié !',
    'this winnings ticket is expired!': 'Ce ticket de gain est expiré !',
    home: 'Accueil',
    'select all': 'Tout sélectionner',
    'select event': "Sélectionnez l'événement",
    continue: 'Continuer',
    'please select a date': 'Veuillez sélectionner une date',
    'transaction completed!': 'Opération terminée !',
    'transaction completed': 'Transaction confirmée',
    betslip: 'panier',
    'cart empty': 'panier vide',
    'continue paying': 'Continuer à parier',
    success: 'Succès',
    min: 'Minimum',
    max: 'Maximum',
    'quick pick': 'Sélection rapide',
    'add to cart': 'Ajouter au panier',
    'please choose the game': 'Veuillez choisir votre tirage',
    'add bets': 'Ajouter vos paris',
    'gains valides pendant 7 jours': 'Gains valides pendant 7 jours',
    'fortune aux parieurs et bénéfice à la Nation': 'Fortune aux parieurs et bénéfice à la Nation',
    'betslip cart': 'Ticket',
    'betslip id': 'ID ticket:',
    multiple: 'Combinés',
    lines: 'évèn',
    'total odds': 'Total cotes:',
    'possible Winnings': 'Gains potentiels',
    single: 'Simple',
    'wager ticket': 'Mise',
    reallotto: 'Loto 5/90',
    'bitville-sports': 'Sports',
    summary: 'Sommaire',
    'true balance': 'Montant à déposer',
    lotto: 'Loto',
    'at least one of the events passed is invalid. please provide valid events.':
        "Un des évènements sélectionnés est erroné. Veuillez en choisir d'autres.",
    settings: 'Paramètres',
    'select printer': 'Select.  imp.',
    'use inner-printer': 'Utiliser impr. intégrée',
    printers: 'Imprimantes',
    'refresh printer list': 'Rafraîchir',
    refresh: 'Rafraîchir',
    'found no printer!': 'Aucune imprimante disponible!',
    "go to device's bluetooth setting to add printer.": 'Allez dans paramètres Bluetooth pour ajouter imprimante.',
    'draw name': 'Nom du tirage',
    'draw time': 'Heure du Tirage',
    'draw number': 'Numéros gagnants',
    'rebet completed!': 'Rebet terminé !',
    rebet: 'Rebet',
    'bonus percent': 'Bonus combinés',
    'database error': "Veuillez contacter l'administrateur, votre solde est bloqué.",
    'from must be before to!': 'FROM must be before TO!',
    result2: 'Tirages',
    'change account': 'Changer De Compte',
    replay: 'Rejouer',
    'replay completed!': 'Rejouer terminé !',
    'not allow rebet': "Ce ticket n'est pas autorisé à rebet !",
    from: 'de',
    to: 'a',
    'report final': 'Rapport Final',
    'download apk': 'Téléch. APK',
    'you are at latest version already': 'Vous êtes déjà à la dernière version',
    'feature is not available yet': "Fonctionnalité non disponible pour l'instant",
    'report date': 'Date du rapport',
    'print date': "Heure d'impression",
    'sports ticket': 'PARIS SPORT',
    'loto ticket': 'LOTO TICKET',
    'confirm final print':
        'Attention, en effectuant ce processus, vous fermez vos ventes pour la journée. Le terminal sera "En attente" jusqu\'à votre dépôt. En cas d\'erreur, contactez votre support.',
    yes: 'OUI',
    history: 'HISTORIQUE',
    'last 5 ticket': 'Vos 5 derniers tickets',
    'created at': 'Horaire',
    'transaction id': 'Identifiant de transaction',
    status: 'Statut',
    'cancel ticket': 'Annulé ticket',
    'are you sure you would like to cancel this bet?': "Veuillez confirmer l'annulation du ticket?",
    cancelled: 'Annulé',
    cancelling: "En cours d'annulation",
    'these bets have passed the cutoff date and have already started':
        'Ce paris ne peut être annulé- évènement déjà en cours',
    'ticket is cancelled': 'Le billet est annulé',
    'please make sure that you select [number] of balls!': 'Attention ! Choisissez [number] numéros.',
    'select a date': 'Choisissez une date',
    'select the event': 'Sélectionner un tirage',
    'transaction history': 'Historique',
    'your last [length] tickets': 'Vos  [length] derniers tickets',
    'your last [length] ticket': 'Vos [length] derniers ticket',
    'turbo [number]': 'turbo [number]',
    'nap [number]': 'nap [number]',
    'chance [number]': 'chance [number]',
    bet: 'Mise',
    'bets [quantity]': 'Mise [quantity]',
    earnings: 'Gains',
    winning: 'Gains',
    selection: 'Sélection',
    'loto [title]': 'Loto [title]',
    'loto payouts': 'Gains Loto',
    'loto turbo winnings': 'Gains Loto Turbo',
    'number of winning numbers': 'Nombre de numéros gagnants',
    odds: 'Probabilités',
    'results - change to loto 5/90': 'Résultats - aller au Loto 5/90',
    'no result': 'Pas de résultat',
    'next date': 'Prochaine date',
    'previous date': 'Date précédente',
    'please login!': 'Veuillez vous connecter !',
    'transaction failed': 'La transaction a échoué',
    'no data': 'pas de données',
    'invalid credentials.': "les informations d'identification invalides",
    'lotto 6 of 45': 'Loto 6/45',
    'loto 6/45': 'Loto 6/45',
    'select game': 'Sélectionnez le jeu',
    'cancel successfully': 'annuler avec succès',
    "we're not allow rebet for 6/45": "Nous n'autorisons pas le rebet pour 6/45",
    'invalid account credentials, please contact technical support.':
        "informations d'identification de compte invalides, veuillez contacter le support technique.",
    "veuillez contacter l'administrateur, votre solde est bloqué. ou votre revendeur temrinal id est bloqué":
        "Veuillez contacter l'administrateur, votre solde est bloqué. ou votre revendeur temrinal id est bloqué",
    'numbers n': 'Num. gagnants',
    payout: 'Allocation gains',
    'odds (1 over)': 'Probabilités (sur 1)',
    'match numbers': 'Numéros correspondants',
    winners: 'Gagnants',
    'loto 6/45 winnings': 'Gains Loto 6/45',
    'lotto-6-45': 'Loto 6/45',
    combination: 'Combinaison',
    multipleprint: 'Multiple',
    simple: 'Simple',
    'bons numéros': 'Bons numéros',
    'type de pari': 'Type de Pari',
    'nbre numéros': 'Nbre numéros',
    'nbre combinaisons': 'Nbre combinaisons',
    'prix ticket': 'Prix ticket',
    gnf: 'GNF',
    'nombre de combinaisons par type de pari': 'Nombre de combinaisons par type de Pari',
    'répartition des gains': 'Répartition des Gains',
    'multiple[number]': 'Multiple[number]',
    'attention, balance en cours trop élevée!, contactez votre administrateur pour mettre à jour.':
        'Attention, balance en cours trop élevée!, Contactez votre administrateur pour mettre à jour.',
    'request timeout. please check your network connection.':
        'Expiration de la demande. Veuillez vérifier votre connexion réseau.',
    'pari simple': 'Pari Simple : Sélection 6 numéros, 1 combinaison, mise 5 000 GNF',
    multiple7: 'Multiple 7 : Sélection 7 numéros, 7 combinaisons,  mise 5 000 GNF x 7 = 35 000 GNF.',
    multiple8: 'Multiple 8 : Sélection 8 numéros, 28 combinaisons, mise 5 000 GNF x 28 = 140 000 GNF.',
    multiple9: 'Multiple 9 : Sélection 9 numéros, 84 combinaisons,  mise 5 000 GNF x 84 = 420 000 GNF.',
    multiple10: 'Multiple 10 : Sélection 10 numéros, 210 combinaisons,  mise  5 000 GNF x 210 = 1 050 000 GNF.',
    'draw this week': 'Tirage de cette semaine:',
    'next draws': 'Prochain tirages:',
    '1 numéro': '1 numéro',
    '2 numéros': '2 numéros',
    '3 numéros': '3 numéros',
    '4 numéros': '4 numéros',
    '5 numéros': '5 numéros',
    '0 numéro + 2 bonus': '0 numéro + 2 bonus',
    '0 numéro + 1 bonus': '0 numéro + 1 bonus',
    '1 numéro + 1 bonus': '1 numéro + 1 bonus',
    '1 numéro + 2 bonus': '1 numéro + 2 bonus',
    '2 numéros + 2 bonus': '2 numéros + 2 bonus',
    '2 numéros + 1 bonus': '2 numéros + 1 bonus',
    '3 numéros + 1 bonus': '3 numéros + 1 bonus',
    '3 numéros + 2 bonus': '3 numéros + 2 bonus',
    '4 numéros + 1 bonus': '4 numéros + 1 bonus',
    sports: 'Sport',
    'earnings before deduction': 'Gains avant retenue:',
    'withholding [tax]': 'Retenue ([tax]):',
    'potential earnings': 'Gains potentiels:',
    'test print': "test d'impression",
    'numbers betting': 'NUMBERS BETTING',
    numbersbetting: 'Numbers',
    'new pin and confirm pin do not match': 'New pin and confirm pin do not match',
    'transaction identifier: [id]': 'transaction identifier: [id]',
    'log-in detaillant': 'Log-in Detaillant',
    'user id': 'User ID',
    lucky: 'Loto 5/90',
    'okapi lottery': 'Multi loto 5/90',
    'multi loto 5/90': 'loto 5/90',
    'lotto-opaki-5-90-lucky5': 'Lucky 5',
    'lotto-opaki-5-90-lucky4': 'Lucky 4',
    'lotto-opaki-5-90-lucky3': 'Lucky 3',
    'please input terminal and terminal pin': 'Veuillez saisir le terminal et la broche du terminal',
    'this field is required': 'Ce champ est obligatoire',
    'sign out': 'Se déconnecter',
    abouts: 'À Propos',
    loto: 'Loto 5/90',
    selected: 'Choisie',
    'choose your number': 'Choisissez votre numéro',
    'no ticket': 'Non',
    type: 'Taper',
    numbers: 'Nombres',
    time: 'Temps',
    action: 'Action',
    'try to turn on bluetooth so inner-printer can work properly': `Pour activer le Bluetooth afin que l'imprimante interne fonctionne correctement!`,
    play: 'JOUEZ',
    'lucky 5': 'Lucky 5',
    'lucky 4': 'Lucky 4',
    'lucky 3': 'Lucky 3',
    'sports betting': 'PARIS SPORT',
    'lotto daily': 'Loto 5/90',
    'lotto-daily': 'Lotto',
    reprint: 'réimpression',
    'gab lotto limited': 'Gab Lotto Limitée',
    'about bames': 'à propos du jeu',
    'game name': 'Nom Du Jeu',
    stake: 'Mise',
    stakes: 'Mises',
    'machine numbers': 'nombres de machine',
    'draw numbers': 'Tirer des numéros',
    'please enter the ticket code': 'Veuillez entrer le code du billet.',
    'ticket number not correct for this transaction': `Le numéro de billet n'est pas correct pour cette transaction`,
    'size': 'taille',
    'large': 'grand(e)',
    'normal': 'normal(e)',
    'winning numbers': 'Numéros gagnants',
    'Stake amount not entered': 'Montant de mise non saisi',
    'pay winnings': 'Payer les gains',
    'processing winnings': 'Traitement des gains',
    'this is valid for [date] days ending': 'Ceci est valable pour [date] jours se terminant.'
};
